import React from 'react'

import { BaseCountByDateAndEntityWidget } from './BaseCountByDateAndEntityWidget'

export const CountByDateAndUserWidget = () => {
  return (
    <BaseCountByDateAndEntityWidget
      dataSourceKey="responseCountsByDateAndUser"
      entityIdField="user_id"
      getEntityName={(dataPoints) => `${dataPoints[0].first_name} ${dataPoints[0].last_name}`}
      entityColumnLabel="Agent"
      entityTooltipLabel="users"
    />
  )
}
